export default "__VITE_ASSET__ee4701e2__"